export default "__VITE_ASSET__DJo3AnM7__"